import React from 'react';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { Container } from '@atlassian/jira-servicedesk-automation-common/src/view/global-error/styled';
import GlobalError from '@atlassian/jira-servicedesk-automation-common/src/view/global-error/view.tsx';
import messages from './messages';

type Props = {
	errorMessage: string;
	onReload: () => void;
	intl: IntlShape;
};

function PageError(props: Props) {
	const {
		errorMessage,
		onReload,
		intl: { formatMessage },
	} = props;
	return (
		<Container>
			<GlobalError
				onClick={onReload}
				actionDescription={formatMessage(messages.reload)}
				description={errorMessage || formatMessage(messages.defaultError)}
			/>
		</Container>
	);
}

export default injectIntl(PageError);
